import React from "react";
import "./MessagePanel.css";
import SimpleCard from "../../theme/simpleCard/SimpleCard";

const MessagePanel = ({ imageUrl, sectionname, title, message, cardarray }) => {
  return (
    <section aria-label={sectionname || "message"} className="message-card">
      {sectionname && (
        <h3 className="h3-secondary profile-sectionname">{sectionname}</h3>
      )}
      <div
        className={`card-content ${!message && cardarray ? "only-cardarray" : ""}`}
      >
        {(imageUrl || title) && (
          <div className="profile-column">
            {imageUrl ? (
              <img src={imageUrl} alt={sectionname} className="profile-image" />
            ) : (
              <div className="profile-image profile-image-placeholder"></div>
            )}
            {title && (
              <div className="profile-text">
                <p className="paragraph-title profile-title">{title}</p>
              </div>
            )}
          </div>
        )}
        {message && (
          <div className="message-section">
            {message.map((line, index) => (
              <React.Fragment key={index}>
                {line.contentHeading && (
                  <h3 className="message-text-heading">
                    {line.contentHeading}
                  </h3>
                )}
                <p className="message-text">{line.content}</p>
              </React.Fragment>
            ))}
          </div>
        )}
        {cardarray && (
          <div className="cardarray-section">
            {cardarray.map((card, index) => (
              <SimpleCard
                key={index}
                imageUrl={card.imageUrl}
                heading={card.heading}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default MessagePanel;
